import { render } from "./ChartDataTable.vue?vue&type=template&id=6c2cef3e"
import script from "./ChartDataTable.vue?vue&type=script&lang=js"
export * from "./ChartDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__